/** Shared network-quality tier for the field device.
 *
 * Backlog 2026-09-18 — a flat resolution/JPEG-quality cut helps a
 * consistently weak connection but wastes real quality on a good one.
 * `FieldCommandsHandler` watches LiveKit's own `ConnectionQualityChanged`
 * signal for the local participant and drives this store; both the live
 * capture resolution (via `applyQualityTier` in cameraCommands.ts) and
 * the snapshot JPEG quality (`FieldCaptureHandler` / `FieldLayout`) read
 * the SAME tier so the live feed and the captured photo degrade (and
 * recover) together.
 */
import { create } from "zustand";

export type CaptureQualityTier = "high" | "low";

type ConnectionQualityState = {
  tier: CaptureQualityTier;
  setTier: (t: CaptureQualityTier) => void;
};

export const useConnectionQualityStore = create<ConnectionQualityState>(
  (set) => ({
    tier: "high",
    setTier: (t) => set({ tier: t }),
  }),
);
